export const hasFlashPlayer = () => {
  return "undefined" != typeof navigator.mimeTypes["application/x-shockwave-flash"];
};
